import { api_fetch_throws } from "@/api/client.tsx"

/** One item at one warehouse of one distributor. */
export interface SpoilageItemRow {
  source: string
  /** A percentage-of-sales allowance rather than product written off. */
  allowance: boolean
  dc: string | null
  /** Groups the same product across documents and warehouses. */
  item_key: string
  upc: string | null
  item_number: string | null
  description: string | null
  amount: number
  /** Units written off. Null for an allowance, and where the backup states no quantity. */
  units: number | null
  deduction_count: number
  last_invoice_date: string
}

/** What one distributor charged for spoilage, and how much of it the backup itemises. */
export interface SourceSpoilage {
  source: string
  total: number
  itemised: number
  not_itemised: number
  deduction_count: number
  deductions_without_items: number
}

export interface SpoilageByItemResponse {
  sources: SourceSpoilage[]
  items: SpoilageItemRow[]
}

/** Spoilage deductions invoiced on or after `start_date` (`yyyy-MM-dd`), or all of them. */
export async function fetchSpoilageByItem(start_date: string | null): Promise<SpoilageByItemResponse> {
  const query = start_date ? `?start_date=${start_date}` : ""
  return await api_fetch_throws<SpoilageByItemResponse>(`/deduction/spoilage-by-item${query}`)
}
